<template>
  <v-layout row wrap>
    <v-flex xs12>
      <form>
        <v-expansion-panel expand :value="[true]">
          <v-expansion-panel-content>
            <div slot="header">
              <v-icon>mdi-filter-variant</v-icon> Filters
            </div>
            <v-card>
              <v-card-text>
                <v-container fluid grid-list-lg>
                  <v-layout row wrap>
                    <v-flex xl3 lg4 xs6>
                      <v-text-field v-int-mask="{intScale: 11}" v-model="filters.proposalNo" :label="filtersLabel.proposalNo" type="tel" :error-messages="errors.collect('proposalNo')" data-vv-name="proposalNo" :data-vv-as="filtersLabel.proposalNo" v-validate="'numeric'"></v-text-field>
                    </v-flex>
                    <v-flex xl3 lg4 xs6>
                      <v-autocomplete :items="params.intermediaries" v-model="filters.intermediary" :label="filtersLabel.intermediary" item-text="label" item-value="value" data-vv-name="intermediary" :data-vv-as="filtersLabel.intermediary" :error-messages="errors.collect('intermediary')" clearable></v-autocomplete>
                    </v-flex>
                    <v-flex xl3 lg4 xs6>
                      <v-autocomplete :items="params.products" v-model="filters.product" :label="filtersLabel.product" item-text="label" item-value="value" data-vv-name="product" :data-vv-as="filtersLabel.product" :error-messages="errors.collect('product')" clearable></v-autocomplete>
                    </v-flex>
                    <v-flex xl3 lg4 xs6>
                      <v-autocomplete :items="params.busClses" v-model="filters.busCls" :label="filtersLabel.busCls" item-text="label" item-value="value" data-vv-name="busCls" :data-vv-as="filtersLabel.busCls" :error-messages="errors.collect('busCls')" clearable></v-autocomplete>
                    </v-flex>
                    <v-flex xl3 lg4 xs6>
                      <v-autocomplete :items="params.covers" v-model="filters.cover" :label="filtersLabel.cover" item-text="label" item-value="value" data-vv-name="cover" :data-vv-as="filtersLabel.cover" :error-messages="errors.collect('cover')" clearable></v-autocomplete>
                    </v-flex>
                    <v-flex xl3 lg4 xs6>
                      <v-text-field v-model="filters.appName" :label="filtersLabel.appName" :error-messages="errors.collect('appName')" data-vv-name="appName" :data-vv-as="filtersLabel.appName" v-validate="'name|max:60'"></v-text-field>
                    </v-flex>
                    <v-flex xl3 lg4 xs6>
                      <v-autocomplete :items="params.status" v-model="filters.status" :label="filtersLabel.status" item-text="label" item-value="value" data-vv-name="status" :data-vv-as="filtersLabel.status" :error-messages="errors.collect('status')" clearable></v-autocomplete>
                    </v-flex>
                  </v-layout>
                  <transition name="slide-x-transition" mode="out-in">
                    <v-layout row wrap v-if="showDetailFilters">
                      <v-flex xl3 lg4 xs6>
                        <v-text-field v-model="filters.appNricPassport" :label="filtersLabel.appNricPassport" :error-messages="errors.collect('appNricPassport')" data-vv-name="appNricPassport" :data-vv-as="filtersLabel.appNricPassport" v-validate="'alpha_num|max:60'"></v-text-field>
                      </v-flex>
                      <v-flex xl3 lg4 xs6>
                        <v-text-field v-model="filters.coyName" :label="filtersLabel.coyName" :error-messages="errors.collect('coyName')" data-vv-name="coyName" :data-vv-as="filtersLabel.coyName" v-validate="'name|max:60'"></v-text-field>
                      </v-flex>
                      <v-flex xl3 lg4 xs6>
                        <v-text-field v-model="filters.polNo" :label="filtersLabel.polNo" :error-messages="errors.collect('polNo')" data-vv-name="polNo" :data-vv-as="filtersLabel.polNo" v-validate="'entry|max:16'"></v-text-field>
                      </v-flex>
                      <v-flex xl3 lg4 xs6>
                        <v-text-field v-model="filters.usrRefId" :label="filtersLabel.usrRefId" :error-messages="errors.collect('usrRefId')" data-vv-name="usrRefId" :data-vv-as="filtersLabel.usrRefId" v-validate="'entry|max:60'"></v-text-field>
                      </v-flex>
                      <v-flex xl3 lg4 xs6>
                        <cal-picker v-model="filters.entryFrom" :label="filtersLabel.entryFrom" :data-vv-as="filtersLabel.entryFrom" data-vv-name="entryFrom" :error-messages="errors.collect('entryFrom')"></cal-picker>
                      </v-flex>
                      <v-flex xl3 lg4 xs6>
                        <cal-picker v-model="filters.entryTo" :label="filtersLabel.entryTo" :data-vv-as="filtersLabel.entryTo" data-vv-name="entryTo" :error-messages="errors.collect('entryTo')"></cal-picker>
                      </v-flex>
                      <v-flex xl3 lg4 xs6>
                        <cal-picker v-model="filters.acceptDateFrom" :label="filtersLabel.acceptDateFrom" :data-vv-as="filtersLabel.acceptDateFrom" data-vv-name="acceptDateFrom" :error-messages="errors.collect('acceptDateFrom')"></cal-picker>
                      </v-flex>
                      <v-flex xl3 lg4 xs6>
                        <cal-picker v-model="filters.acceptDateTo" :label="filtersLabel.acceptDateTo" :data-vv-as="filtersLabel.acceptDateTo" data-vv-name="acceptDateTo" :error-messages="errors.collect('acceptDateTo')"></cal-picker>
                      </v-flex>
                    </v-layout>
                  </transition>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-btn flat="flat" @click.native="showDetailFilters = true" v-if="!showDetailFilters">Show More Filters</v-btn>
                <v-spacer></v-spacer>
                <v-btn color="red darken-1" flat="flat" @click.native="doClearFilters">Clear Filters</v-btn>
                <v-btn color="primary" flat="flat" type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
              </v-card-actions>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </form>
    </v-flex>
    <v-flex xs12 class="mt-3">
      <message :messages="messages"></message>
    </v-flex>
    <v-flex xs12>
      <v-layout row>
        <v-spacer></v-spacer>
        <v-menu offset-x :nudge-left="370" :close-on-content-click="false" :min-width="300" :max-height="400">
          <v-btn color="secondary" class="white--text" slot="activator">
            <span>Columns</span>
            <v-icon right dark>mdi-table-column-plus-after</v-icon>
          </v-btn>
          <v-card>
            <v-card-text>
              <template v-if="columns.length > 0">
                <v-checkbox v-for="column in columns" :key="column.value" :label="column.text" :value="column.value" v-model="selectedColumns"></v-checkbox>
              </template>
              <template v-else>
                No column found
              </template>
            </v-card-text>
          </v-card>
        </v-menu>
      </v-layout>
    </v-flex>
    <v-flex xs12 class="mt-2">
      <v-data-table :headers="listHeaders" :items="items" :pagination.sync="pagination" :total-items="totalItems" :loading="loading" class="elevation-1" :rows-per-page-items="itemsPerPage" :no-data-text="noDataText">
        <template slot="items" slot-scope="props">
          <td v-for="column in selectedColumns" :key="column">
            {{props.item[column]}}
          </td>
          <td class="text-xs-right">
            <table-action :rowData="props" :review="canReview(props)" :query="checkAccess(['cargoQuote' , 'cargoQuoteQuery'])" @query="doQuery(props)" @review="doReview(props)" :loading="loading"></table-action>
          </td>
        </template>
      </v-data-table>
    </v-flex>
  </v-layout>
</template>

<script>
import clone from 'clone'
import { listQuoteMixin } from '../shared/listQuoteMixin'
import { quoteStatus } from '@/const/underwriting'
import { expandURI, filterQuery } from '@/utils/ajax'
import toDate from 'date-fns/toDate'
import isAfter from 'date-fns/isAfter'
import { removeTime, setEndTime, formatDisplayDateTime2, removeFormatDate } from '@/utils/date'

export default {
  data() {
    return {
      columns: [
        { text: 'Proposal No.', align: 'left', value: 'proposalNo' },
        { text: 'Product', value: 'product' },
        { text: 'Intermediary', value: 'intermediary' },
        { text: 'Cover', value: 'cover' },
        { text: 'Business Class', value: 'busCls' },
        { text: 'Sum Insured Currency', value: 'siCurr' },
        { text: 'Declared Sum Insured', sortable: false, value: 'siDeclared' },
        { text: 'Premium', value: 'premium' },
        { text: 'Applicant Name', value: 'appName' },
        { text: 'Company Name', value: 'coyName' },
        { text: 'Status', value: 'status' },
        { text: 'NRIC/Passport', value: 'appNricPassport' },
        { text: 'Policy No', value: 'polNo' },
        { text: 'Acceptance Date', value: 'acceptDate' },
        { text: 'Entry Date', value: 'createdDate' },
        { text: 'User Ref Id', value: 'usrRefId' }
      ],
      selectedColumns: ['proposalNo', 'intermediary', 'product', 'coyName', 'premium', 'status', 'createdDate'],
      filtersLabel: {
        proposalNo: 'Proposal No.',
        intermediary: 'Intermediary',
        product: 'Product',
        busCls: 'Business Class',
        cover: 'Cover Type',
        appName: 'Applicant Name',
        coyName: 'Company Name',
        status: 'Status',
        appNricPassport: 'NRIC/Passport',
        polNo: 'Policy No.',
        acceptDateFrom: 'Acceptance Date From',
        acceptDateTo: 'Acceptance Date To',
        entryFrom: 'Entry Date From',
        entryTo: 'Entry Date To',
        usrRefId: 'User Ref Id'
      },
      filters: {
        proposalNo: null,
        intermediary: null,
        product: null,
        busCls: null,
        cover: null,
        appName: null,
        coyName: null,
        status: null,
        appNricPassport: null,
        polNo: null,
        acceptDateFrom: null,
        acceptDateTo: null,
        entryFrom: null,
        entryTo: null,
        usrRefId: null
      },
      params: {
        intermediaries: [],
        products: [],
        status: [],
        busClses: [],
        covers: []
      },
      showDetailFilters: false,
      reviewDays: undefined
    }
  },
  methods: {
    async fetchData(options) {
      if (this.apiUrl) {
        try {
          this.loading = true
          const { page, rowsPerPage } = this.pagination
          const expand = {
            page: page - 1,
            size: rowsPerPage,
            options
          }
          // Massage the filters
          let massageFilters = clone(this.filters)
          if (massageFilters.entryFrom) {
            massageFilters.entryFrom = formatDisplayDateTime2(removeTime(massageFilters.entryFrom))
          }
          if (massageFilters.entryTo) {
            massageFilters.entryTo = formatDisplayDateTime2(setEndTime(massageFilters.entryTo))
          }
          if (massageFilters.acceptDateFrom) {
            massageFilters.acceptDateFrom = formatDisplayDateTime2(removeTime(massageFilters.acceptDateFrom))
          }
          if (massageFilters.acceptDateTo) {
            massageFilters.acceptDateTo = formatDisplayDateTime2(setEndTime(massageFilters.acceptDateTo))
          }
          const result = await this.$http.get(filterQuery(expandURI(this.apiUrl, expand), massageFilters, this.pagination.sortBy, this.pagination.descending))
          if (result.data) {
            this.totalItems = result.data.totalElements
            this.reviewDays = result.data.reviewDays
            const { data } = result.data
            if (data) {
              // Format the data here
              this.items = []
              data.map((quote) => {
                const convertQuote = {
                  proposalNo: quote.proposalNo,
                  product: quote.productName,
                  busCls: quote.busClsName,
                  cover: quote.cvrTypeName,
                  intermediary: quote.intermediaryName,
                  siCurr: quote.siCurr,
                  siDeclared: quote.siDeclared,
                  premium: this.formatNumber(quote.premium),
                  appName: quote.appName,
                  coyName: quote.coyName,
                  status: quote.status ? quoteStatus[quote.status] : '',
                  statusCode: quote.status,
                  appNricPassport: quote.appNricPassport,
                  polNo: quote.polNo,
                  acceptDate: this.formatDate(toDate(quote.acceptDate)),
                  createdDate: this.formatDate(toDate(quote.createdDate)),
                  usrRefId: quote.usrRefId
                }
                this.items.push(convertQuote)
              })
            } else {
              this.items = []
            }
            if (options) {
              this.$set(this.params, 'intermediaries', result.data.intermediaries)
              this.$set(this.params, 'products', result.data.products)
              this.$set(this.params, 'busClses', result.data.busClses)
              this.$set(this.params, 'covers', result.data.covers)
            }
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
    },
    // canReview(data) {
    //   if (this.checkAccess(['cargoQuote'])) {
    //     if (data.item.statusCode === 'NQ' || data.item.statusCode === 'QA' || data.item.statusCode === 'NP') {
    //       return true
    //     } else if (data.item.statusCode === 'QPA' || data.item.statusCode === 'PPA') {
    //       if (this.checkAccess(['cargoQuoteRef'])) {
    //         return true
    //       }
    //     }
    //   }
    //   return false
    // },
    canReview(data) {
      if (this.checkAccess(['cargoQuote'])) {
        if (data.item.statusCode === 'NQ' || data.item.statusCode === 'QA' || data.item.statusCode === 'NP') {
          if (!this.$store.state.agency.quotationSettings.isStaff) {
            const actDate = removeFormatDate(data.item.acceptDate)
            if (this.reviewDays !== null && typeof this.reviewDays !== 'undefined') {
              const reviewDate = new Date(new Date().setDate(new Date().getDate() - this.reviewDays))
              return isAfter(actDate, reviewDate)
            } else {
              return true
            }
          } else {
            return true
          }
        } else if (data.item.statusCode === 'QPA' || data.item.statusCode === 'PPA') {
          if (this.checkAccess(['cargoQuoteRef'])) {
            if (!this.$store.state.agency.quotationSettings.isStaff) {
              const actDate = removeFormatDate(data.item.acceptDate)
              if (this.reviewDays !== null && typeof this.reviewDays !== 'undefined') {
                const reviewDate = new Date(new Date().setDate(new Date().getDate() - this.reviewDays))
                return isAfter(actDate, reviewDate)
              } else {
                return true
              }
            } else {
              return true
            }
          }
        }
      }
      return false
    },
    doQuery(data) {
      this.$router.push({ name: 'cargoQuoteQuery', params: { id: data.item.proposalNo } })
    },
    async doReview(data) {
      try {
        this.loading = true
        const dispatchObj = {
          proposalNo: data.item.proposalNo,
          query: false
        }
        await this.$store.dispatch('loadQuote', dispatchObj)

        // Check status and redirect to the correct page
        // Check status and redirect to the correct page
        if (data.item.statusCode === 'NQ') {
          this.$router.push({ name: 'cargoQuote' })
        } else if (data.item.statusCode === 'QPA') {
          this.$router.push({ name: 'cargoQuoteRef' })
        } else if (data.item.statusCode === 'QA') {
          this.$router.push({ name: 'cargoQuoteAccept' })
        } else {
          this.$snotify.error('Invalid Status Code')
        }

        // Dont have to set loading to false here. It should have been redirected
        // If somehow error occurs, by right they cant try to load again. Might have dirty data now
        // this.loading = false
      } catch (err) {
        if (err.response && err.response.data) {
          this.fullMessage(err.response.data)
        } else if (err.message) {
          this.errorMessage(err.message)
        }
        this.loading = false
      }
    },
    doClearFilters() {
      this.filters.proposalNo = null
      this.filters.intermediary = null
      this.filters.product = null
      this.filters.busCls = null
      this.filters.cover = null
      this.filters.appName = null
      this.filters.coyName = null
      this.filters.status = null
      this.filters.appNricPassport = null
      this.filters.polNo = null
      this.filters.acceptDateFrom = null
      this.filters.acceptDateTo = null
      this.filters.entryFrom = null
      this.filters.entryTo = null
      this.fetchData(false)
    },
    doFilters() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          // Reset to page 1
          this.pagination.page = 1
          this.fetchData(false)
        }
      })
    }
  },
  created() {
    this.apiUrl = this.listState.menu.cargo

    // Default some params from const
    this.$set(this.params, 'status', [{
      value: 'NQ',
      label: quoteStatus['NQ']
    }, {
      value: 'QPA',
      label: quoteStatus['QPA']
    }, {
      value: 'QA',
      label: quoteStatus['QA']
    }, {
      value: 'QD',
      label: quoteStatus['QD']
    }, {
      value: 'IF',
      label: quoteStatus['IF']
    }, {
      value: 'PO',
      label: quoteStatus['PO']
    }, {
      value: 'VO',
      label: quoteStatus['VO']
    }, {
      value: 'NTU',
      label: quoteStatus['NTU']
    }, {
      value: 'CL',
      label: quoteStatus['CL']
    }, {
      value: 'DC',
      label: quoteStatus['DC']
    }])
  },
  mixins: [
    listQuoteMixin
  ]
}
</script>

<style lang="scss">
</style>
